import _ from 'lodash'
import FileSaver from 'file-saver'
import moment from 'moment-timezone'

import api from '@/api/api'

import MenuMoreOptions from '@/components/general/menu-more-options/menu-more-options'
import TextField from '@/components/general/fields/text/text'
import SelectField from '@/components/general/fields/select/select'
import CheckboxField from '@/components/general/fields/checkbox/checkbox'
import DateField from '@/components/general/fields/date/date'

export default {
  name: 'reports-master-data',
  data () {
    return {
      contracts: [],
      filters: {
        since: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.reports.master_data.filters.since'),
          error: false,
          active: false,
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        until: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.reports.master_data.filters.until'),
          error: false,
          active: false,
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        exported: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.reports.master_data.filters.exported_options.all'),
          value: 'all',
          name: this.$t('private.reports.master_data.filters.exported'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.reports.master_data.filters.exported_options.all'),
            value: 'all'
          }, {
            fakeValue: this.$t('private.reports.master_data.filters.exported_options.only_exported'),
            value: 'only_exported'
          }, {
            fakeValue: this.$t('private.reports.master_data.filters.exported_options.not_exported'),
            value: 'not_exported'
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        limit: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.reports.master_data.filters.limit_options.10'),
          value: 10,
          name: this.$t('private.reports.master_data.filters.limit'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.reports.master_data.filters.limit_options.10'),
            value: 10
          }, {
            fakeValue: this.$t('private.reports.master_data.filters.limit_options.25'),
            value: 25
          }, {
            fakeValue: this.$t('private.reports.master_data.filters.limit_options.50'),
            value: 50
          }, {
            fakeValue: this.$t('private.reports.master_data.filters.limit_options.100'),
            value: 100
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        skip: {
          value: 0
        }
      },
      getContractsActive: false,
      activateFilters: false,
      haveData: false,
      nextPage: false,
      selectedContracts: [],
      allChecks: [],
		 activateAllCheckbox: {
			 id: _.uniqueId('field_'),
			 display: true,
			 error: false,
			 value: {
				 all: false,
				 active: false

			 },
			 options: {
				 all: {
					 name: this.$t('private.reports.master_data.table.pages_options.all'),
					 disabled: false
				 },
				 active: {
					 name: this.$t('private.reports.master_data.table.pages_options.current'),
					 disabled: false
				 }
			 },
			 filters: {
				 type: 'manyOptions'
			 },
			 style: {
				 width: '120px'
			 }
		 },
      exportMasterDataActive: false
    }
  },
  methods: {
    getContracts () {
      let vm = this

      vm.getContractsActive = true
      vm.contracts = []

      let exported = vm.filters.exported.value == 'all' ? '' : vm.filters.exported.value == 'only_exported'

      let since = vm.filters.since.value ? moment(vm.filters.since.value).startOf('day').toDate() : ''
      let until = vm.filters.until.value ? moment(vm.filters.until.value).endOf('day').toDate() : ''

      let dataToSend =
				'/?state=' + 0 +
				'&descending=' + 'appCreationDate' +
				'&since=' + since +
				'&until=' + until +
				'&exported=' + exported +
				'&limit=' + (vm.filters.limit.value + 1) +
				'&skip=' + vm.filters.skip.value +
				'&virtualSignApproved=false'

      api
				.contracts
				.getContracts(dataToSend)
				.then((response) => {
  vm.getContractsActive = false

  if (response.status != 200) {
    let message = {
      message: [vm.$t('errors.custom.001')],
      type: 'error'
    }

    vm.$root.$emit('showMessage', message)

    return
  }

  if (!response.data.success) {
    let message = {
      message: [vm.$t('errors.custom.001')],
      type: 'error'
    }

    vm.$root.$emit('showMessage', message)

    return
  }

  let contracts = []

  _.each(response.data.contracts, function (element) {
    let wellaTotalDiscount = element.wellaDiscount + element.wellaVariableDiscount

    element.wellaTotalDiscount = !_.isNaN(wellaTotalDiscount) ? wellaTotalDiscount : 0
    let premiumDiscount1 = element.premiumDiscount1 ? element.premiumDiscount1 * 1 : 0
    let premiumVariableDiscount1 = element.premiumVariableDiscount1 ? element.premiumVariableDiscount1 * 1 : 0
    element.premiumDiscountTotal = premiumDiscount1 + premiumVariableDiscount1

    let prestigeDiscount1 = element.prestigeDiscount1 ? element.prestigeDiscount1 * 1 : 0
    let prestigeVariableDiscount1 = element.prestigeVariableDiscount1 ? element.prestigeVariableDiscount1 * 1 : 0
    element.prestigeDiscountTotal = prestigeDiscount1 + prestigeVariableDiscount1

    let associatedAccounts = []

    if (element.associatedAccount1) {
      associatedAccounts.push(element.associatedAccount1)
    }

    if (element.associatedAccount2) {
      associatedAccounts.push(element.associatedAccount2)
    }

    if (element.associatedAccount3) {
      associatedAccounts.push(element.associatedAccount3)
    }

    if (element.associatedAccount4) {
      associatedAccounts.push(element.associatedAccount4)
    }

    if (element.associatedAccount5) {
      associatedAccounts.push(element.associatedAccount5)
    }

    if (associatedAccounts.length == 0) {
      contracts.push(element)

      return
    }

    _.each(associatedAccounts, (associatedAccount) => {
      let contract = _.clone(element)

      contract.associatedAccount = associatedAccount

      contracts.push(contract)
    })
  })

  vm.contracts = contracts

  if (vm.contracts.length > 0 && !vm.haveData) {
    vm.haveData = true
  }

  if (vm.contracts.length > vm.filters.limit.value) {
    vm.nextPage = true

    vm.contracts.pop()
  } else {
    vm.nextPage = false
  }

  vm.allChecks = _.map(vm.contracts, (contract) => {
    let field = {
      id: _.uniqueId('field_'),
      display: true,
      error: false,
      value: {},
      options: {},
      filters: {
        type: 'manyOptions'
      }
    }

    field.value[contract.id] = false

    field.options[contract.id] = {}

    return field
  })
})
    },
    goToBackPage () {
      let vm = this

      if (vm.filters.skip.value != 0) {
        vm.filters.skip.value = vm.filters.skip.value - vm.filters.limit.value

        vm.getContracts()
      }
    },
    goToNextPage () {
      let vm = this

      if (vm.nextPage) {
        vm.filters.skip.value = vm.filters.skip.value + vm.filters.limit.value

        vm.getContracts()
      }
    },
	  activateAllCheckboxToggle() {

		  let vm = this

		  vm.selectedContracts = []

		  if (vm.activateAllCheckbox.value.active || vm.activateAllCheckbox.value.all) {

			  for (let i = 0; i < vm.allChecks.length; i++) {

				  for (let j in vm.allChecks[i].value) {

					  vm.allChecks[i].value[j] = true

				  }

			  }

		  } else {

			  for (let i = 0; i < vm.allChecks.length; i++) {

				  for (let j in vm.allChecks[i].value) {

					  vm.allChecks[i].value[j] = false

				  }

			  }

		  }

		  if (vm.activateAllCheckbox.value.all) vm.activateAllCheckbox.options.active.disabled = true
		  else vm.activateAllCheckbox.options.active.disabled = false

		  if (vm.activateAllCheckbox.value.active) vm.activateAllCheckbox.options.all.disabled = true
		  else vm.activateAllCheckbox.options.all.disabled = false

	  },
	  exportData() {

		  let vm = this

		  if (vm.contracts.length == 0) return

		  let selectedContracts = vm.activateAllCheckbox.value.active ? _.map(vm.allChecks, 'value') : vm.selectedContracts

		  let contracts = _.filter(selectedContracts, (element) => {

			  if (!element) {

				  return false

			  }

			  let key = ''

			  for (let i in element) {

				  key = i

			  }

			  return element[key]

		  })


		  contracts = _.map(contracts, (element) => {

			  let key = ''

			  for (let i in element) {

				  key = i

			  }

			  return key

		  })

		  if (contracts.length == 0 && !vm.activateAllCheckbox.value.all) {
			  let message = {
				  message: [vm.$t('private.reports.master_data.export.no_data')],
				  type: 'error'
			  }

			  vm.$root.$emit('showMessage', message)

			  return


		  }

		  if (vm.exportMasterDataActive) {

			  let message = {
				  message: [vm.$t('private.reports.master_data.please_wait')],
				  type: 'error'
			  }

			  vm.$root.$emit('showMessage', message)

			  return

		  }

		  vm.exportMasterDataActive = true

		  let since = vm.filters.since.value ? moment(vm.filters.since.value).startOf('day').toDate() : '';
		  let until = vm.filters.until.value ? moment(vm.filters.until.value).endOf('day').toDate() : '';
		  let exported = vm.filters.exported.value == 'all' ? '' : vm.filters.exported.value == 'only_exported' ? 'true' : 'false';

		  let dataToSend = {
			  descending: 'appCreationDate',
			  state: '0',
			  since: since,
			  until: until,
			  exported: exported,
			  timeZone: moment.tz.guess()
		  }

		  if (contracts.length > 0 && !vm.activateAllCheckbox.value.all) dataToSend['contracts'] = contracts
		  if (vm.activateAllCheckbox.value.all) dataToSend['limit'] = vm.totalContracts

		  api
			  .reports
			  .exportMasterData(dataToSend)
			  .then((response) => {

				  vm.exportMasterDataActive = false
				  vm.selectedContracts = []

				  if (response.status != 200) {

					  let message = {
						  message: [vm.$t('errors.custom.001')],
						  type: 'error'
					  }

					  vm.$root.$emit('showMessage', message)

					  return

				  }

				  let file = new Blob([response.data], { type: 'application/vnd.ms-excel' })
				  let fileURL = URL.createObjectURL(file)

				  FileSaver.saveAs(file, 'master_data.xlsx')

				  vm.getContracts()

			  })

	  },
    parseDate (date) {
      return moment(date).format('DD-MM-YYYY')
    },
    validateDateCTO (contract) {
      let vm = this

      let currentDate = moment(contract.appCreationDate)

      if (contract.prorated && contract.proratedMonth) {
        let date = moment(contract.appCreationDate).month(contract.proratedMonth - 1).startOf('month')
        if (date.isAfter(currentDate)) date = date.subtract(1, 'year')
        return date.format('DD-MM-YYYY')
      }

      return contract.startDateOfPeriod

			// return contract.prorated && contract.proratedMonth ? moment(contract.appCreationDate ).month(contract.proratedMonth).format('DD-MM-YYYY') : contract.startDateOfPeriod;
    },
    parseBrands (brands) {
      const _bransd = {
        1: 'Wella',
        2: 'SP',
        3: 'Nioxin',
        4: 'SSP',
        5: 'Sassoon',
        6: 'Sebastian'
      }

      let parseBransObjs = []

      if (brands && brands.length > 0) {
        _.each(brands, (value) => {
          parseBransObjs.push(_bransd[value])
        })

        return parseBransObjs.map(k => k).join(', ')
      } else {
        return ''
      }
    },
    getAgreement (contract, key) {
      let agreements = []

      if (contract[`${key}1`]) agreements.push(contract[`${key}1`])
      if (contract[`${key}2`]) agreements.push(contract[`${key}2`])
      if (contract[`${key}3`]) agreements.push(contract[`${key}3`])

      return agreements.join(' - ')
    },
    concatValues (items_1, items_2, items_3) {
      let values = []
      if (items_1) values.push(items_1)
      if (items_2) values.push(items_2)
      if (items_3) values.push(items_3)

      return _.uniq(values).join('/')
    }
  },
  components: {
    MenuMoreOptions,
    TextField,
    SelectField,
    CheckboxField,
    DateField
  },
  created () {
    let vm = this

    vm.getContracts()
  }
}



// WEBPACK FOOTER //
// ./src/components/private/reports/master-data/script.js